import { withAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import OrderBaseList from 'components/Tables/OrderBaseList';

export default withAuth0(withAuthenticationRequired(class UnshippedOrders extends OrderBaseList {
  getListParams = () => ({ unshipped_orders: 'Y', show_all: 'true' });

  getPageTitle = () => 'Unshipped Orders';

  contentDisplay = () => this.getInnerTableContent();

  getTableClassSettings = () => 'wm_short_table';

  getStorageName = () => 'otto_my_wm_unshipped_orders_list';
}));
